import React, { memo } from "react"

interface TagProps {
    children?: React.ReactNode
    colorScheme?: 'green' | 'red' | 'yellow' | 'blue' | 'gray',
    isLoading?: boolean,
    className?: string
    size?: 'sm' | 'lg'
}

const Tag: React.FC<TagProps> = ({ children, colorScheme = 'gray', isLoading, className, size = 'sm' }) => {
    const sizeClasses = {
        sm: `leading-6 text-base px-1 lg:px-2 ${isLoading ? `h-5 !w-10` : ``}`,
        lg: `leading-6 text-base px-1 lg:leading-8 lg:text-lg lg:px-3 lg:py-1 ${isLoading ? `h-5 !w-10 lg:h-8 lg:!w-14` : ``}`,
    }[size]
    const baseClasses = `rounded-md text-center font-normal w-fit whitespace-nowrap ${sizeClasses} ${isLoading ? `bg-gray-400 animate-pulse` : ``}`;
    const colorSchemeClasses = {
        green: "bg-[#71C02B] text-white",
        yellow: "bg-[#FFC100] text-[#000]", 
        red: "bg-[#FF4747] text-white",
        gray: "bg-[#E0E0E0] text-black",
        blue: "bg-blue-500 text-white"
    }[colorScheme];

    return (
        <div className={`${baseClasses} ${colorSchemeClasses} ${className}`}>
            {children}
        </div>
    )
}

export default memo(Tag)

